<template>
  <div>
    <SkeletonLoaderTitleUpdate v-show="showSkeleton" />

    <div class="ma-4" v-show="!showSkeleton">
      <div class="text-h4 mb-4">Atualizar Pesquisa de Satisfação {{ description }}</div>
    </div>
    <div v-if="canRender">
      <CadastroPesquisaSatisfacao edicao="true" :_id="_id" />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import { registerVuexModule } from '@/utils/vuexUtils'
import SkeletonLoaderTitleUpdate from '@/componentes/SkeletonLoaderTitleUpdate'

import pesquisaSatisfacaoStore from '../_store'

import CadastroPesquisaSatisfacao from './CadastroPesquisaSatisfacao'

export default {
  props: {
    _id: String,
  },
  components: { SkeletonLoaderTitleUpdate, CadastroPesquisaSatisfacao },

  data: () => ({
    description: '',
    showSkeleton: false,
    canRender: false,
  }),

  computed: {
    ...mapGetters('atualizarPesquisaSatisfacaoModulePesquisaSatisfacaoStore', ['getPesquisaSatisfacaoEspecifica']),
  },

  async created() {
    this.showSkeleton = true
    registerVuexModule(this.$store, 'atualizarPesquisaSatisfacaoModulePesquisaSatisfacaoStore', pesquisaSatisfacaoStore)

    await this.listarPesquisaSatisfacaoEspecifica(this._id)
    this.description = this.getPesquisaSatisfacaoEspecifica.description

    this.showSkeleton = false
    this.canRender = true
  },

  methods: {
    ...mapActions('atualizarPesquisaSatisfacaoModulePesquisaSatisfacaoStore', ['listarPesquisaSatisfacaoEspecifica']),
  },
}
</script>
